// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Chatbot/components/index.css
// module id = 460
// module chunks = 0